import { Booking } from "../types/booking";
import { getBookingEffReference } from "./bookingUtils";

export const filterBookingsBySearchText = (
  bookings: Booking[],
  search: string
): Booking[] => {
  const q = search.trim().toLowerCase();
  if (!q) return bookings;

  return bookings.filter((b) => {
    const company = Array.isArray(b.company_info)
      ? b.company_info[0]
      : b.company_info;
    const container = Array.isArray(b.container_info)
      ? b.container_info[0]
      : b.container_info;
    const transport = Array.isArray(b.transport_type_info)
      ? b.transport_type_info[0]
      : b.transport_type_info;
    const bookingType = Array.isArray(b.booking_type_info)
      ? b.booking_type_info[0]
      : b.booking_type_info;
    const haystack = [
      String(b.id),
      getBookingEffReference(b),
      b.reference,
      company?.name,
      container?.reference,
      transport?.name,
      bookingType?.name,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
};
